<template>
    <div class="home">
        <audio id="bgm" autoplay="autoplay" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <p :class="music ? 'music zhuan' : 'music'" @click="stopmusic"></p>
        <img src="../static/person.png" class="person" alt="">
        <img src="../static/title.png" class="title" alt="">


        <div class="words-box">
            <img src="../static/hands.png" class="hands" alt="">
            <p class="words theline" @click="opendetails(3)">
                <span class="dot " ></span> “一寸木头”，感动兰城 ——追悼“中国好人”姚宝熙
            </p>
          
            <p class="words theline" @click="opendetails(2)">
                <span class="dot"></span> 凡人不凡  寸木不朽——揭秘“中国好人”姚宝熙
            </p>
            <p class="words " @click="opendetails(1)">
                <span class="dot" ></span> 爱心传递，润泽家乡——赓续“中国好人”姚宝熙的精神
            </p>
        </div>

        <Details v-if="ifDetails" class='details' @child-event="closedetails" :id="id"></Details>
    </div>
</template>

<script>
function autoPlay (id) {
    console.log(3333);
    
    let audio = document.getElementById(id)
    audio.volume = 0.5
    let play = function () {
      audio.play()
      document.removeEventListener("touchstart", play, false)
    }
    audio.play()
    document.addEventListener("WeixinJSBridgeReady", function () {
      play()
    }, false)
    document.addEventListener('YixinJSBridgeReady', function () {
      play()
    }, false)
    document.addEventListener("touchstart", play, false)
  }
import Details from './details.vue';
export default {
    components: {
        Details
    },
    data() {
        return {
            more:false,
            id: '',
            music: true,
            ifDetails: false,
        }
    },
    methods: {
        opendetails(a) {
         if (this.music) {
            document.getElementById("bgm").play()
         }
            if (a == 1) {
                this.id = 1645822
            } else if (a == 2) {
                this.id = 1644985
            } else if (a == 3) {
                this.id = 1642695
            } 

            this.ifDetails = true
        

        },
        closedetails() {
            // document.getElementById("scene").style=""
         
            this.ifDetails = false

        },

        stopmusic() {
            let audio = document.getElementById("bgm");
            if (this.music == true) {
                this.music = false;
                audio.pause();
            } else {
                this.music = true;
                audio.volume = 0.5
                audio.play();
            }
        },
    },
    mounted() {
        autoPlay("bgm")
    },
}
</script>

<style lang="less">
.home {
    width: 375px;
    height: 100vh;
    background: url("../static/bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .music {
        position: fixed;
        width: 30px;
        height: 30px;
        top: 20px;
        right: 20px;
        background: url("../static/music.png") center no-repeat;
        background-size: 100% 100%;
        z-index: 2;

        &.zhuan {
            animation: music 2s linear infinite;

            @keyframes music {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }
    .person {
        position: absolute;
        width: 375px;
        top: 80px;
        animation: an-person 4s ease-out 1 normal;

        @keyframes an-person {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .title {
        position: absolute;
        width: 280px;
        top: 50px;
        left: 80px;
        animation: an-title 3s ease-in 1 normal;

        @keyframes an-title {
            0% {
                opacity: 0;
                left: 500px;
                top: -50px;
            }

            100% {
                opacity: 1;
                left: 80px;
                top: 50px;
            }
        }
    }

    .words-box {
        position: absolute;
        width: 330px;
        height: 120px;
        bottom: 90px;
        left: 50%;
        margin-left: -165px;
        background: linear-gradient(to bottom, #ffffff, #decac4);
        border-radius: 20px;
        padding: 10px 20px;
        box-sizing: border-box;
        animation: an-words 6s ease-out 1 normal;

        @keyframes an-words {
            0% {
                opacity: 0;
            }
            50%{
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

        .hands {
            position: absolute;
            width: 30px;
            z-index: 2;
            right: 20px;
            top: 30px;
            animation: turn 1s linear infinite;

            @keyframes turn {
                0% {
                    top: 30px;
                    right: 20px;
                }



                50% {
                    top: 35px;
                    right: 15px;
                }



                100% {
                    top: 30px;
                    right: 20px;
                }
            }
        }

        .theline {
            border-bottom: 1px solid #000;
            /* 1px 是下划线的粗细，#000 是颜色 */
            // display: inline;
        }

        .words {
            line-height: 35px;
            font-size: 11px !important;
            // transform: scale(1.1);

            .dot {
                position: relative;
                padding-left: 20px;
                /* 为小圆点留出空间 */
            }

            .dot::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 7px;
                height: 7px;
                background-color: #7b6d67;
                /* 小圆点的颜色 */
                border-radius: 50%;
                /* 使元素变为圆形 */
            }
        }
    }

    .details {
        position: fixed;
      
        width: 375px;
        height: 100%;
        background-color: #fff;
        z-index: 10;
        overflow: hidden;
        overflow-y: scroll;
        // padding-bottom: 60px;
    }
}
</style>